import { useAppSelector } from "src/common/state/hooks";
import { useTranslation } from "react-i18next";
import { errorSelector } from "../../state/slice/appStateSlice";
import type { RootState } from "../../state/store";

export const useError = (componentId: string) => {
  const { error } = useAppSelector((state: RootState) => {
    return {
      error: errorSelector(state, componentId),
    };
  });
  return error;
};

export const Error = ({
  componentId,
  errorString,
}: {
  componentId: string;
  errorString?: string;
}) => {
  const error = useError(componentId);
  const { t } = useTranslation();

  const displayError = error && error.includes(".") ? t(error, error) : error;

  return (
    <>
      {error && error !== "" && (
        <span className="text-red-500">{errorString ? errorString : displayError}</span>
      )}
    </>
  );
};
